export const esData = `
  <div class="paragraph">
    <div class="page-title">Preguntas Frecuentes sobre el Programa de Recompra (Trade-In)</div>
  </div>
  <div class="paragraph">
    <div class="title">¿Quién puede participar en el programa de recompra?</div>
    <div class="text-box">
      <div class="text">
        El Servicio de recompra está disponible exclusivamente para personas físicas mayores de 18 años que residan legalmente en un Estado miembro de la Unión Europea, excluidas las Islas Canarias, las Islas Baleares, Ceuta y Melilla.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué debo hacer antes de enviar mi dispositivo antiguo?</div>
    <div class="text-box">
      <div class="text">
        Antes de enviarlo:<br>
        • Elimina todos los datos personales y cualquier PIN, contraseña o patrón de bloqueo de pantalla.<br>
        • Realiza un restablecimiento completo de fábrica.<br>
        • En iPhone: desconecta tu cuenta de iCloud desactivando "Buscar mi iPhone".<br>
        • En Android: elimina tu cuenta de Google (Ajustes > Cuentas > Google > Eliminar cuenta).<br>
        • En cámaras de acción: Elimine cualquier cuenta vinculada, borre todos los archivos multimedia, formatee la tarjeta de memoria (si corresponde) y realice un restablecimiento completo a los ajustes de fábrica.<br>
        Esto garantiza que el dispositivo no esté vinculado a tu cuenta y protege tu información personal.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Cómo puedo enviar mi dispositivo antiguo?</div>
    <div class="text-box">
      <div class="text">
        <strong>Embalaje:</strong> utiliza una caja resistente y opaca (no transparente) e incluye protección interna (plástico de burbujas o similar) para evitar daños durante el transporte.<br>
        <strong>Materiales de embalaje:</strong> si no dispones de materiales de embalaje adecuados, podrás solicitarlos en el punto de entrega al dejar tu paquete.<br>
        <strong>Documentación:</strong> imprime, completa y firma la Declaración de Integridad y colócala dentro del paquete antes de sellarlo.<br>
        <strong>Sellado seguro:</strong> asegúrate de que el paquete esté bien cerrado y coloca la etiqueta de envío gratuita en un lugar visible.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué tipos de dispositivos no se aceptan?</div>
    <div class="text-box">
      <div class="text">
        No aceptamos dispositivos que:<br>
        •	estén bloqueados por operador (SIM-lock);<br>
        •	no enciendan o no carguen;<br>
        •	no puedan conectarse por Bluetooth o Wi-Fi;<br>
        •	presenten fallos en componentes internos o en la placa base;<br>
        •	no puedan tomar fotografías o grabar vídeos correctamente;<br>
        •	tengan lentes agrietadas o daños estructurales graves;<br>
        •	tengan botones defectuosos o problemas de estabilización;<br>
        •	hayan estado expuestos a líquidos o hayan sido reparados o desmontados;<br>
        •	sigan vinculados a iCloud, Google o cualquier cuenta de usuario;<br>
        •	sean falsificaciones o réplicas;<br>
        •	estén gravemente dañados.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Debo enviar también los accesorios (cargador, cable, etc.)?</div>
    <div class="text-box">
      <div class="text">
        No es obligatorio, pero sí recomendable. Incluir los accesorios contribuye a la sostenibilidad y a la correcta reutilización del dispositivo.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Debo enviar los auriculares?</div>
    <div class="text-box">
      <div class="text">
        No. Por motivos de higiene, los auriculares serán desechados y no se incluirán en la evaluación.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Debo enviar la factura de compra?</div>
    <div class="text-box">
      <div class="text">
        No es necesaria para la evaluación ni para el pago. Puedes conservarla para tus propios registros.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Cómo se evalúa mi dispositivo antiguo?</div>
    <div class="text-box">
      <div class="text">
        Utilizamos software de diagnóstico certificado y realizamos una inspección manual en nuestro centro de valoración para determinar el estado de tu dispositivo. Todos los procedimientos de evaluación y tratamiento de datos se realizan conforme al Reglamento General de Protección de Datos (RGPD – UE 2016/679), garantizando la seguridad y confidencialidad de tu información.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué ocurre si el estado que indiqué no coincide con vuestra evaluación?</div>
    <div class="text-box">
      <div class="text">
        Si existen diferencias entre la condición que declaraste y nuestra evaluación, te enviaremos un correo electrónico con:<br>
        •	<strong>Una oferta actualizada</strong> basada en la inspección real.<br>
        •	<strong>El informe de diagnóstico</strong> y los motivos de la diferencia.<br><br>
        Podrás elegir aceptar o rechazar la oferta:<br>
        •	Si la aceptas, la recompra se completará y recibirás el pago en tu cuenta bancaria en un plazo de 3 días laborables.<br>
        •	Si la rechazas, el proceso de devolución dependerá de tu ubicación:<br>
        &nbsp;&nbsp;•	Para todos los clientes: se aplicará una tarifa de devolución, con un máximo de 22 EUR (IVA incluido).<br>
        &nbsp;&nbsp;•	El importe deberá abonarse dentro de los cinco (5) días naturales siguientes a la recepción de la solicitud de pago, utilizando la etiqueta oficial de devolución prepagada proporcionada por Danghuan.<br>
        &nbsp;&nbsp;•	Los detalles de pago se facilitarán a petición o se incluirán en el correo electrónico con el enlace de pago.<br>
        &nbsp;&nbsp;•	Una vez confirmado el pago (si aplica), Danghuan verificará la transacción en un plazo de 5 días laborables y organizará el envío de devolución a tu dirección original. Se te notificará por correo electrónico una vez que el paquete haya sido expedido, incluyendo la información de seguimiento correspondiente.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué pasa si no respondo a la oferta actualizada?</div>
    <div class="text-box">
      <div class="text">
        Si no se recibe respuesta dentro de los cinco (5) días naturales desde la fecha de notificación, la oferta revisada se considerará aceptada automáticamente.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué sucede con mis datos personales?</div>
    <div class="text-box">
      <div class="text">
        Debes eliminar todos los datos antes de enviar tu dispositivo antiguo.<br>
        Si detectamos información personal residual, pausaremos el proceso y te contactaremos para que la elimines. Cumplimos plenamente con el RGPD (Reglamento UE 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Quién paga los gastos de envío?</div>
    <div class="text-box">
      <div class="text">
        El primer envío siempre es gratuito.<br><br>
        Si rechazas la oferta actualizada:<br>
        •	Para todos los clientes: se aplicará una tarifa de devolución, con un máximo de 22 EUR (IVA incluido).<br>
        •	El importe deberá abonarse dentro de los cinco (5) días naturales siguientes a la recepción de la solicitud de pago, utilizando la etiqueta oficial de devolución prepagada proporcionada por Danghuan.<br>
        •	Los detalles de pago se facilitarán a petición o se incluirán en el correo electrónico con el enlace de pago.<br>
        •	Una vez confirmado el pago (si aplica), Danghuan verificará la transacción en un plazo de 5 días laborables y organizará el envío de devolución a tu dirección original. Se te notificará por correo electrónico una vez que el paquete haya sido expedido, incluyendo la información de seguimiento correspondiente.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Qué pasa si mi paquete se pierde durante el envío?</div>
    <div class="text-box">
      <div class="text">
        Si tu dispositivo se pierde durante el transporte, Danghuan Europe S.L. te asistirá en el proceso oficial de reclamación con la empresa de mensajería.<br><br>
        Un envío se considerará perdido si no ha sido registrado, confirmado o recibido por Danghuan en un plazo de 15 días naturales desde su entrega al transportista.<br><br>
        •	Debes utilizar la etiqueta de envío prepagada autorizada por Danghuan; el uso de otro método anulará la cobertura por pérdida.<br>
        •	Las reclamaciones a UPS deben presentarse dentro de los 60 días desde la creación de la etiqueta.<br>
        •	Para envíos de CORREOS (España), las reclamaciones deben realizarse lo antes posible, preferiblemente dentro de los 15 días y como máximo dentro de 1 año desde la fecha de envío.<br>
        •	Danghuan ayudará en la investigación con la empresa de transporte, la cual suele tardar entre 30 y 60 días.<br><br>
        Si la pérdida se confirma dentro del sistema logístico de Danghuan y se utilizó la etiqueta autorizada, la compensación no superará el valor final de recompra tasado del dispositivo.<br><br>
        Los pagos aprobados se transferirán directamente al IBAN indicado durante el registro.<br><br>
        <em>Nota: Cualquier compensación dependerá de la política de la empresa de mensajería.</em>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Cuándo recibiré el pago?</div>
    <div class="text-box">
      <div class="text">
        Una vez aceptada la oferta final, el pago se realizará por transferencia bancaria en un plazo de 3 días laborables. Asegúrate de que tu IBAN y tu Número de Identificación Personal sean correctos y coincidan con el titular de la cuenta.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Es obligatorio proporcionar mi Número de Identificación Personal?</div>
    <div class="text-box">
      <div class="text">
        Sí. Para procesar el pago, debes facilitar un Número de Identificación Personal válido, sin espacios ni caracteres especiales, y que coincida con el titular del IBAN.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">¿Puedo cancelar mi operación de recompra?</div>
    <div class="text-box">
      <div class="text">
        Sí, si tu dispositivo aún no ha sido pagado. Por favor, contáctanos lo antes posible a insta360@danghuan.eu. Si ya enviaste tu dispositivo, contacta con nosotros dentro de las 48 horas; de lo contrario, el proceso de reciclaje continuará de forma normal.
      </div>
    </div>
  </div>
`;